/**
 * @file permissions.js
 * @location src/utils/permissions.js
 * @role 권한 resolver — 매니저(사람 단위, member.isManager) 단일 축
 *
 * razor ⑳ 직급 폐기: 직급(orgLevels)·전체열람(seeAllTasks)·페이지 권한(navAccess) 전부 폐기.
 * 권한 축은 isManager 하나 — 매니저 / 팀원. 페이지 접근은 NAV_ITEMS.managerOnly + isManager 로 가드.
 */

/**
 * 멤버가 매니저인가 — member.isManager 직접 참조 (사람 단위).
 * member 가 falsy (삭제·미발견) 면 false. pending 멤버도 false (호출 측 가드와 정합).
 */
export function isManager(member) {
  return !!member?.isManager;
}

/**
 * 의미별 권한 게이트 — 현재는 전부 isManager(매니저/팀원)에 위임한다.
 * 부매니저(미래 member.role) 도입 시 권한별로 이 함수들만 분기한다(호출부·데이터 불변).
 *   canManageMembers  인원 페이지 접근 · 멤버 CRUD · managerOnly nav
 *   canSeeAllTasks    전사 업무 가시성 (visibility 가 사용)
 *   canAssignTasks    업무 발신(발신)
 *   canManageTask     업무 편집 / 중지 / 삭제
 */
export const canManageMembers = (member) => isManager(member);
export const canSeeAllTasks   = (member) => isManager(member);
export const canAssignTasks   = (member) => isManager(member);
export const canManageTask    = (member) => isManager(member);
